function getDefaultDimension() {
    return {
        value: undefined,
        deviation: undefined,
        term: undefined,
        unit: undefined,
    };
}

export const orderNew = {
    comm: undefined,
    terms: {
        user: [],
    },
    loadingPortDetails: '',
    unloadingPortDetails: '',
    ldRates: {
        discharging: {
            quantity: undefined,
            dimension: undefined,
            speed: undefined,
            abbreviation: undefined,
            term: undefined,
            type: undefined,
        },
        loading: {
            quantity: undefined,
            dimension: undefined,
            speed: undefined,
            abbreviation: undefined,
            term: undefined,
            type: undefined,
        },
    },
    cargo: [{
        cargoName: '',
        details: 0,
        cargoTypeName: '',
        cargoType: '',
        dangerous: {
            value: false,
            class: [],
            unNumber: '',
        },
        packing: {
            category: 'unpacked',
            pack: {
                name: undefined,
                unitsQuantity: undefined,
                unitsQuantityIsCalc: true,
                sf: '',
                sfUnit: 'cbm/mt',
                unitsWeight: [
                    {
                        value: undefined,
                        unit: 'mt',
                        deviation: undefined,
                        deviationSign: {
                            sign1: '+', 
                            sign2: '-',
                        },
                    }, 
                    {
                        value: undefined,
                        unit: 'mt',
                        deviation: undefined,
                    },
                ],
                unitsVolume: [
                    {
                        value: undefined,
                        unit: 'cbm',
                        deviation: undefined,
                        deviationSign: {
                            sign1: '+', 
                            sign2: '-',
                        },
                    },
                    {
                        value: undefined,
                        unit: 'cbm',
                        deviation: undefined,
                    },
                ],
                unitWeight: {
                    ...getDefaultDimension(),
                    unit: 'mt',
                },
                unitVolume: {
                    value: undefined,
                    unit: 'm3',
                },
                temperatureMin: undefined,
                temperatureMax: undefined,
                moistureMin: undefined,
                moistureMax: undefined,
                numberOfHeadsMin: undefined,
                numberOfHeadsMax: undefined,
                weightPerHead: undefined,
                ventilation: false,
                maxUnitLength: {
                    ...getDefaultDimension(),
                    unit: 'mm',
                },
                unitBeam: {
                    ...getDefaultDimension(),
                    unit: 'mm',
                },
                unitHeight: {
                    ...getDefaultDimension(),
                    unit: 'mm',
                },
                stackable: {
                    value: false,
                    tiers: undefined,
                    dunnaging: false,
                    nested: false,
                },
                unitLength: {
                    ...getDefaultDimension(),
                    unit: 'mm',
                },
                maxUnitWidth: {
                    ...getDefaultDimension(),
                    unit: 'mm',
                },
                unitDiam: {
                    ...getDefaultDimension(),
                    unit: 'mm',
                },
                density: undefined,
                pourPointMin: undefined,
                pourPointMax: undefined,
                boilingPointMin: undefined,
                boilingPointMax: undefined,
                flashPointMin: undefined,
                flashPointMax: undefined,
                densities: [{ density: undefined, temperature: undefined }],
                meltingPointMin: undefined,
                meltingPointMax: undefined,
                flammable: false,
                voyageHeatMin: undefined,
                voyageHeatMax: undefined,
                loadingHeatMin: undefined,
                loadingHeatMax: undefined,
                dischargeHeatMin: undefined,
                dischargeHeatMax: undefined,
                maxAdjacentHeat: undefined,
                bundleBeam: {
                    ...getDefaultDimension(),
                    unit: 'mm',
                },
                bundleHeight: {
                    ...getDefaultDimension(),
                    unit: 'mm',
                },
                bundleLength: {
                    ...getDefaultDimension(),
                    unit: 'mm',
                },
                bundlesQuantity: undefined,
                netWeight: {
                    ...getDefaultDimension(),
                    unit: 'mt',
                },
            },
        },
        containerDetails: {
            kind: undefined,
            ownNum: undefined,
            sealNum: undefined,
            owner: 'shipper',
            stc: undefined,
            terms: undefined,
        },
        packingList: [
            {
                name: undefined,
                weight: undefined,
                weightIsCalc: false,
                length: undefined,
                width: undefined,
                height: undefined,
                quantity: undefined,
                totalWeight: undefined,
                imdg: undefined,
                grossWeight: undefined,
                netWeight: undefined,
                taraWeight: undefined,
                area: undefined,
                areaIsCalc: false,
                volume: undefined,
                volumeIsCalc: false,
            },
        ],
        validateErrors: [],
        hsCodeId: { _id: undefined, text: undefined },
        additionalCargoDetails: undefined,
        typeOfTransportation: 'breakbulk',
        clauses: [
            { name: 'Shipment', value: 'under deck' },
            { name: 'Cradles to be for', value: 'Charterer\'s account' },
        ],
    }],
    clientRefNo: undefined,
    incoterms: {
        kind: undefined,
        place: undefined,
    },
    totalValues: {
        weight: undefined,
        weightWithPercent: undefined,
        volume: undefined,
        volumeWithPercent: undefined,
        isCalc: true,
    },
    details: 0,
    contract: '',
    cancellingDate: '',
    readinessDate: '',
    unloadingPort: '',
    loadingPort: '',
    validateErrors: [],
    loadingPortName: '',
    unloadingPortName: '',
    loadingPorts: [
        {
            namePort: '',
            idPort: '',
            cancellingDate: '',
            readinessDate: '',
            additionalLayCanDetails: undefined,
            layCanType: 'layCan',
        },
    ],
    unloadingPorts: [
        {
            namePort: '',
            idPort: '',
        },
    ],
    loadingPortsNew: [
        {
            oneOf: [
                {
                    cancellingDate: '',
                    readinessDate: '',
                    andOr: '',
                    port: '',
                    portName: '',
                    details: undefined,
                    additionalLayCanDetails: undefined,
                    layCanType: 'layCan',
                },
            ],
        },
    ],
    unloadingPortsNew: [
        {
            oneOf: [
                {
                    andOr: '',
                    port: '',
                    portName: '',
                    details: undefined,
                },
            ],
        },
    ],
    loadingPortsMap: [
        {
            port: {
                andOr: 'and',
                cancellingDate: '',
                readinessDate: '',
                details: undefined,
                portName: '',
                additionalLayCanDetails: undefined,
                layCanType: 'layCan',
            },
            sign: 'and',
        },
    ],
    unloadingPortsMap: [
        {
            port: {
                andOr: 'and',
                details: undefined,
                portName: '',
            },
            sign: 'and',
        },
    ],
    user: '',
};



// WEBPACK FOOTER //
// ./app/mocks/cargo/orderNew.js